export const currentSharedExperienceSelector = (state) => state.currentSharedExperience;
